import React from "react";
import InfoSection from "../../common/InfoSection";
import { teamDetails } from "../../../constants/data";

const Team = () => {
  return (
    <div
      id="team"
      className="max-w-1200 mx-auto w-full"
    >
      <div className="px-4 sm:px-16 lg:px-0 py-5 sm:py-20">
        <div className="flex flex-col gap-14 sm:gap-2.5 lg:gap-20">
          <InfoSection
            title="OUR TEAM"
            subtitle="Meet The Team"
            description="At RegTechFlow, we’ve built a community of innovative minds dedicated to creating a groundbreaking global compliance platform. Our team brings together experienced professionals and new talent, working collaboratively to create innovative solutions and advance together."
            width="max-w-2xl"
            descriptionHidden={false}
            titleClass='lg:hidden'
          />
         <div className="grid grid-cols-2 lg:grid-cols-4 justify-center items-start gap-5 sm:gap-y-8 lg:gap-y-16 sm:gap-x-8 max-sm:max-w-[360px] max-lg:max-w-[584px] max-lg:mx-auto">
          {teamDetails.map(({ name, profileImg, post }, index) => {
            const isLast = index === teamDetails.length - 1;
            const isOdd = teamDetails.length % 2 !== 0;
            const centerLastMobile = isLast && isOdd ? 'max-lg:col-span-2 max-lg:justify-self-center max-sm:max-w-[170px] max-lg:max-w-[260px]' : '';

            return (
              <div
                key={index}
                className={`rounded-lg transition-shadow duration-300 flex flex-col items-center gap-2.5 sm:gap-4 lg:gap-6 max-lg:mx-auto ${centerLastMobile}`}
              >
                <div className="relative rounded-3xl size-full">
                  {profileImg ? (
                    <img
                      src={profileImg}
                      alt={profileImg}
                      className="object-fit rounded-3xl w-full h-[170px] sm:h-[280px] max-lg:mx-auto"
                    />
                  ) : (
                    <div className="bg-white/60 rounded-3xl w-full h-[170px] sm:h-[280px] max-lg:mx-auto" />
                  )}
                </div>
                <div className="flex flex-col items-center flex-grow text-center">
                  <h3 className="text-sm sm:text-2xl text-darkBlue lg:text-darkGray font-bold mb-2 leading-tight">
                    {name}
                  </h3>
                  <p className="text-[10px] sm:text-base text-darkGray flex-grow">{post}</p>
                </div>
              </div>
            );
          })}
        </div>

        </div>
      </div>
    </div>
  );
};

export default Team;
